<!-- Entity resolved -->
@if (entity() && !loading()) {
  @if (showJubiAnimation() && shouldLoadJubiImages()) {
    @defer (on idle) {
      <div
        class="fixed inset-0 z-[150] top-[60px] md:top-0 flex items-start justify-center pointer-events-none"
      >
        @let imgClasses = 'absolute mx-auto inset-0 w-full';
        @let srcset =
          '320w, 420w, 520w, 620w, 720w, 820w, 920w, 1020w, 1120w, 1220w, 1320w, 1420w, 1620w, 1920w, 2220w, 2520w, 2820w, 3000w';
        @let sizes = '(min-width: 3000px) 3000px, 100vw';
        @let dimension = '3000';
        <img
          ngSrc="dynamic/noop/79c94c4192540afe8101895792c4bb23721ef96f.gif"
          priority
          [width]="dimension"
          [height]="dimension"
          [ngSrcset]="srcset"
          [sizes]="sizes"
          (load)="onJubiImageLoad()"
          [class.hidden]="
            !(
              jubiAnimationState() === 'in' ||
              (jubiAnimationState() === 'out' && !jubiAnimInHideDelay())
            )
          "
          [class]="imgClasses"
        />
        <img
          ngSrc="dynamic/noop/eb0053c8bb705e8773cdea4a5286961a136f0c35.gif"
          priority
          [width]="dimension"
          [height]="dimension"
          [ngSrcset]="srcset"
          [sizes]="sizes"
          [class.hidden]="jubiAnimationState() !== 'out'"
          [class]="imgClasses"
        />
      </div>
    }
  }

  <!-- Show unpublished tag -->
  @if (!entity()!.published && entity()!.type !== 'webform') {
    <div class="flex justify-end fixed top-[120px] z-[1000] mobi-ui-container">
      <div class="mobi-ui-badge-major is-small mobi-ui-ink-pink w-auto">
        {{ 'unpublished' | texts: { context: 'frontend', default: 'Unveröffentlicht' } }}
      </div>
    </div>
  }
  <div
    [class.hidden]="forceHide()"
    class="mobi-ui-container"
    [attr.data-page-bundle]="trackingAttributes()['page-bundle'] || null"
    [attr.data-page-contentphase]="trackingAttributes()['page-contentphase'] || null"
    [attr.data-page-segment]="trackingAttributes()['page-segment'] || null"
    [attr.data-page-subject]="trackingAttributes()['page-subject'] || null"
    [attr.data-product-name]="trackingAttributes()['product-name'] || null"
    [attr.data-product-id]="trackingAttributes()['product-id'] || null"
    [attr.data-product-variant]="trackingAttributes()['product-variant'] || null"
    [mobiTracking]="trackingAttributes()"
  >
    <!-- If the entity is behind a cooke wall and the consent is not given -->
    @if (entity()!.cookieWall && !getConsent(entity())) {
      @defer (on idle) {
        <mobi-cookie-consent-page
          (emitAcceptCookies)="acceptCookies()"
          [cookieType]="entity()!.cookieWall!"
        />
      }
    }
    <!-- If the entity is not protected or it is hidden behind the cookie wall and has consent -->
    @if (!entity()?.cookieWall || (entity()?.cookieWall && getConsent(entity()))) {
      <mobi-node-loader
        [bundle]="entity()!.bundle"
        [params]="queryParams"
        [data]="{ entity: entity() }"
      />
    }
  </div>
}

<!-- Unknown error occured -->
@if (hasError() && !notFound()) {
  <div class="mobi-ui-container mobi-b2c-margin-y">
    <div class="mobi-ui-container mobi-ui-margin-y-xxl">
      <mobi-hero-text
        [title]="
          'something_went_wrong'
            | texts
              : {
                  context: 'frontend',
                  default: 'Da ist etwas schiefgelaufen...',
                }
        "
        [lead]="
          'please_reload'
            | texts
              : {
                  context: 'frontend',
                  default:
                    'Bitte laden Sie die Seite neu oder versuchen Sie es später noch einmal.',
                }
        "
      ></mobi-hero-text>
    </div>
  </div>
}

<!-- Page not found -->
@if (notFound()) {
  @defer (on immediate) {
    <div class="mobi-ui-container">
      <mobi-page-not-found />
    </div>
  }
}
